/**
 * Possible category types of the user notifications
 */
export enum NotificationCategory {
  Trade,
  News,
  System,
  Promotions
}


/**
 * 🔨 Converts text to NotificationCategory
 * @param categoryAsText 
 */
export function toNotificatonCategory(categoryAsText: string): NotificationCategory {
  switch (categoryAsText) {
    case "system": return NotificationCategory.System;
    case "trade": return NotificationCategory.Trade;
    case "news": return NotificationCategory.News;
    case "promo": return NotificationCategory.Promotions;
    default: return NotificationCategory.System;
  }
}

/**
 * 🔨 Converts NotificationCategory to text
 * @param notificationCategory 
 */
export function toString(notificationCategory: NotificationCategory): string {
  switch (notificationCategory) {
    case NotificationCategory.System: return "system";
    case NotificationCategory.Trade: return "trade";
    case NotificationCategory.News: return "news";
    case NotificationCategory.Promotions: return "promo";
  }
}